import styled from 'styled-components';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import 'react-dates/lib/css/_datepicker.css';
import { DayPickerRangeController } from 'react-dates';
import Spacer from '../Spacer';
import moment from 'moment';

const OuterContainer = styled.div``;

const Container = styled.div`
  border: 1px solid #ecedf7;
  border-radius: 7px;
  display: inline-flex;
  justify-content: space-between;
  padding: 3px;
  font-size: 12px;
  align-items: center;
  color: #9092c1;
`;

const LeftArrow = styled.div`
  padding: 7px 10px;
  border-radius: 5px;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    background: #f2f3f9;
  }
`;

const Content = styled.div`
  padding: 7px 18px;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    background: #f2f3f9;
  }
  border-radius: 5px;
  font-weight: 500;
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const RightArrow = styled.div`
  padding: 7px 10px;
  border-radius: 5px;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    background: #f2f3f9;
  }
`;

const DatePicker = styled.div`
  position: absolute;
  z-index: 10;
`;

type Props = {
  startDate: string | null;
  endDate: string | null;
  onDatesChange: ({
    startDate,
    endDate,
    forceRender,
  }: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
    forceRender?: boolean;
  }) => void;
  onClose?: () => void;
  rightItems?: React.ReactNode;
};

function DateSelector({
  startDate,
  endDate,
  onClose = () => {},
  onDatesChange,
  rightItems,
}: Props) {
  const [dropped, setDropped] = React.useState(false);
  const [focusedInput, setFocusedInput] = React.useState<
    'startDate' | 'endDate' | null
  >('startDate');

  const sDate = moment(startDate);
  const eDate = moment(endDate);
  return (
    <OuterContainer>
      <TopRow>
        <Container>
          <LeftArrow
            onClick={() => {
              const daysBetween = eDate?.diff(sDate, 'd') + 1;
              onDatesChange({
                startDate: sDate?.subtract(daysBetween, 'day') ?? null,
                endDate: eDate?.subtract(daysBetween, 'day') ?? null,
                forceRender: true,
              });
            }}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </LeftArrow>
          <Content onClick={() => setDropped(!dropped)}>
            {sDate?.format('DD MMMM')} - {eDate?.format('DD MMMM')}
          </Content>
          <RightArrow
            onClick={() => {
              const daysBetween = eDate?.diff(sDate, 'd') + 1;
              onDatesChange({
                startDate: sDate?.add(daysBetween, 'day') ?? null,
                endDate: eDate?.add(daysBetween, 'day') ?? null,
                forceRender: true,
              });
            }}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </RightArrow>
        </Container>
        {rightItems}
      </TopRow>
      <Spacer vertical spacing={2} />
      {dropped && (
        <DatePicker>
          <DayPickerRangeController
            startDate={sDate} // momentPropTypes.momentObj or null,
            endDate={eDate} // momentPropTypes.momentObj or null,
            onDatesChange={onDatesChange} // PropTypes.func.isRequired,
            focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={(f) => {
              if (f === null) {
                f = 'startDate';
              }
              setFocusedInput(f);
            }} // PropTypes.func.isRequired,
            initialVisibleMonth={null} // PropTypes.func or null,
            numberOfMonths={2}
            onOutsideClick={() => {
              onClose();
              setDropped(false);
            }}
            maxDate={moment(new Date())}
          />
        </DatePicker>
      )}
    </OuterContainer>
  );
}

export default DateSelector;
